<template>
  <div class="fontNav">
    <van-tabbar v-model="active" route active-color="#e91200" nactive-color="#7E7E7E" safe-area-inset-bottom>
      <van-tabbar-item replace to="/">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? icon.ahome : icon.home"  class="home"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item  replace to="/goodsKind">
        <span>商品分类</span>
        <template #icon="props">
          <img :src="props.active ? icon.asort : icon.sort" class="sort"/>
        </template>
      </van-tabbar-item>
      <!-- :to="isLogin=='true'?'/shoppingCart':'/login'" -->
      <van-tabbar-item  replace @click="qugouwu('shoppingCart')" >
        <span>购物车</span>
        <template #icon="props">
          <img :src="props.active ? icon.ashopping : icon.shopping" class="shop"/>
        </template>
      </van-tabbar-item>
      <!-- :to="isLogin=='true'?'/myIndex':'/login'"  -->
      <van-tabbar-item replace  @click="qugouwu('myIndex')">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon.amy : icon.my"  class="my"/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      icon: {
        home: require('../assets/localImage/icon_home1.png'),
        ahome: require('../assets/localImage/icon_home2.png'),
        sort: require('../assets/localImage/icon_sort1.png'),
        asort: require('../assets/localImage/icon_sort2.png'),
        shopping: require('../assets/localImage/icon_Shopping1.png'),
        ashopping: require('../assets/localImage/icon_Shopping2.png'),
        my: require('../assets/localImage/icon_My1.png'),
        amy: require('../assets/localImage/icon_My2.png'),
      },
      isLogin:localStorage.getItem('isLogin')
    };
  },
  props: {},
  created() {
    this.isLogin = localStorage.getItem('isLogin')
  },
  methods: {
    qugouwu(url){
      if(this.isLogin){
        this.$router.push({path: `/${url}`});
      }else{
        localStorage.setItem("redirect_url", window.location.href + url);
        console.log(window.location.href + url)
        this.$router.push({path:'/login'});
      }
    }
  
  }
};
</script>
<style scoped lang='less'>
.fontNav{
    padding-bottom: 100px;
    img{width: 40px;height: 40px;}
    // .home{width: 39px;height: 36px;}
    .sort{width: 38px;height: 38px;}
    // .shop{width: 39px;height: 34px;}
    // .my{width: 42px;height: 42px;}
}
</style>